import React from 'react';
import {
    Box, TextField, MenuItem, Divider, Avatar, IconButton, Tooltip,
    CircularProgress, Typography
} from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import SectionTitle from './SectionTitle';

export default function SecaoConsultorio({
    parametros, psicologos, handleChange,
    handleEnderecoChange, handleBuscaCEP, buscandoCep,
    logoPreview, logoInputRef, handleLogoChange, uploadingLogo
}) {
    return (
        <Box>
            <SectionTitle descricao="Aparece no cabeçalho dos documentos gerados (contratos, declarações).">
                Logo
            </SectionTitle>
            <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap' }}>
                <Box sx={{ position: 'relative' }}>
                    <Avatar
                        src={logoPreview || undefined}
                        variant="rounded"
                        sx={{ width: 120, height: 80, bgcolor: '#f0f0f0', border: '2px dashed #ccc', fontSize: 13, color: '#999' }}
                    >
                        {!logoPreview && 'Logo'}
                    </Avatar>
                    <Tooltip title="Alterar logo">
                        <IconButton size="small" onClick={() => logoInputRef.current?.click()} disabled={uploadingLogo}
                            sx={{ position: 'absolute', bottom: -10, right: -10, bgcolor: '#1ABB9C', color: '#fff', '&:hover': { bgcolor: '#129A80' }, width: 28, height: 28 }}>
                            {uploadingLogo ? <CircularProgress size={14} color="inherit" /> : <PhotoCameraIcon sx={{ fontSize: 14 }} />}
                        </IconButton>
                    </Tooltip>
                    <input ref={logoInputRef} type="file" accept="image/*" hidden onChange={handleLogoChange} />
                </Box>
                <Typography variant="caption" color="text.secondary">
                    Formatos: JPG, PNG, WebP.
                </Typography>
            </Box>

            <Divider sx={{ my: 4 }} />

            <SectionTitle descricao="Vincule psicólogo e endereço para preencher variáveis dos documentos.">
                Dados do consultório
            </SectionTitle>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '2fr 1fr 2fr' }, gap: 2, mb: 3 }}>
                <TextField fullWidth label="Nome do consultório" name="consultorioNome"
                    value={parametros.consultorioNome} onChange={handleChange}
                    placeholder="Ex: Clínica Espaço Terapêutico" />
                <TextField fullWidth label="Telefone" name="consultorioTelefone"
                    value={parametros.consultorioTelefone} onChange={handleChange}
                    placeholder="(44) 99999-9999" />
                <TextField fullWidth select label="Psicólogo responsável"
                    name="idPsicologo" value={parametros.idPsicologo} onChange={handleChange}>
                    <MenuItem value=""><em>Nenhum</em></MenuItem>
                    {psicologos.map(p => (
                        <MenuItem key={p.id_psicologo ?? p.idPsicologo} value={p.id_psicologo ?? p.idPsicologo}>
                            {p.nomeCompleto}{p.crp ? ` — CRP ${p.crp}` : ''}
                        </MenuItem>
                    ))}
                </TextField>
            </Box>

            <SectionTitle>Endereço</SectionTitle>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 3fr 1fr 1fr' }, gap: 2, mb: 2 }}>
                <TextField fullWidth label="CEP" name="cep"
                    value={parametros.endereco.cep}
                    onChange={handleEnderecoChange}
                    onBlur={handleBuscaCEP}
                    placeholder="00000-000"
                    InputProps={{ endAdornment: buscandoCep ? <CircularProgress size={18} /> : null }} />
                <TextField fullWidth label="Logradouro" name="logradouro"
                    value={parametros.endereco.logradouro} onChange={handleEnderecoChange} />
                <TextField fullWidth label="Número" name="numero"
                    value={parametros.endereco.numero} onChange={handleEnderecoChange} />
                <TextField fullWidth label="Complemento" name="complemento"
                    value={parametros.endereco.complemento} onChange={handleEnderecoChange}
                    placeholder="Sala 12, Apto..." />
            </Box>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '2fr 2fr 1fr' }, gap: 2 }}>
                <TextField fullWidth label="Bairro" name="bairro"
                    value={parametros.endereco.bairro} onChange={handleEnderecoChange} />
                <TextField fullWidth label="Cidade" name="nomeCidade"
                    value={parametros.endereco.nomeCidade} onChange={handleEnderecoChange} />
                <TextField fullWidth label="UF" name="ufEstado"
                    value={parametros.endereco.ufEstado} onChange={handleEnderecoChange}
                    inputProps={{ maxLength: 2, style: { textTransform: 'uppercase' } }} />
            </Box>
        </Box>
    );
}
